import CategoryPage from '.';
import createAddUpdateCategory from './CreateUpdate';
import { categoryRoutes } from './routes';

export const createCategoryPage = () => {
  const Category = CategoryPage();
  const AddCategory = createAddUpdateCategory();
  const UpdateCategory = createAddUpdateCategory();

  const Page = categoryRoutes;
  return () => <Page Category={Category} AddCategory={AddCategory} UpdateCategory={UpdateCategory} />;
};


